/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_Go_HomeInputs */

const en_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to home`)
};

const ar_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الانتقال إلى الرئيسية`)
};

const bn_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হোমে যান`)
};

const de_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Startseite`)
};

const es_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir al inicio`)
};

const fr_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à l’accueil`)
};

const pt_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para o início`)
};

const zh_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回家`)
};

const tr_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eve git`)
};

const ru_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Иди домой`)
};

const pl_brand_go_home = /** @type {(inputs: Brand_Go_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idź do domu`)
};

/**
* | output |
* | --- |
* | "Go to home" |
*
* @param {Brand_Go_HomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const brand_go_home = /** @type {((inputs?: Brand_Go_HomeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_Go_HomeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_brand_go_home(inputs)
	if (locale === "bn") return bn_brand_go_home(inputs)
	if (locale === "de") return de_brand_go_home(inputs)
	if (locale === "es") return es_brand_go_home(inputs)
	if (locale === "fr") return fr_brand_go_home(inputs)
	if (locale === "pt") return pt_brand_go_home(inputs)
	if (locale === "zh") return zh_brand_go_home(inputs)
	if (locale === "tr") return tr_brand_go_home(inputs)
	if (locale === "ru") return ru_brand_go_home(inputs)
	if (locale === "pl") return pl_brand_go_home(inputs)
	return en_brand_go_home(inputs)
});